// Default collections and search to the "In stock" filter
(() => {
  const PARAM = 'filter.v.availability';

  // Append the filter to collection links as they're clicked, so dynamic links are covered too.
  // This includes the facet "remove" links, which keeps "In stock" applied when other filters are cleared.
  const addInStock = (event) => {
    const link = event.target.closest('a[href*="/collections/"], a[href*="/search?"]');
    if (!link || link.origin !== location.origin) return;

    const url = new URL(link.href);
    if (url.searchParams.has(PARAM)) return;

    url.searchParams.set(PARAM, '1');
    link.href = url.toString();
  };

  document.addEventListener('click', addInStock, true);
  document.addEventListener('auxclick', addInStock, true);

  // Fallback for landing on an unfiltered collection or search (shared links, search engines, etc.)
  if (!document.currentScript?.hasAttribute('data-default-in-stock')) return;

  document.addEventListener('DOMContentLoaded', () => {
    if (new URLSearchParams(location.search).has(PARAM)) return;

    const inStock = document.querySelector(
      `facet-filters-form input[name="${PARAM}"][value="1"]:not([id$="-no-js"])`
    );
    if (!inStock) return;

    inStock.checked = true;
    inStock.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
